import { defineStore } from "pinia";
import { api, Success, watchRequest, type Result, type ResultOkRef } from "../api";
import { markRaw } from "vue";
import { z } from "zod";
import {
  GoogleKpisSchema,
  OrderKpisSchema,
  type GoogleKpisResponse,
  type OrderKpisResponse,
} from "../schemas/metrics";

export type OrderKpisParams = {
  start: string;
  end: string;
};

class MetricsApi {
  private readonly ordersKpisUrl = "/analytics/kpis/orders/";
  private readonly googleKpisUrl = "/analytics/kpis/google/";
  private readonly checkoutFormsUrl = "/analytics/checkout-forms/";

  touchCheckoutForm(sessionId: string): Promise<Result<void>> {
    return api.post(this.checkoutFormsUrl, z.void(), {
      session_id: sessionId,
    });
  }

  getOrderKpis(
    params: OrderKpisParams,
  ): ResultOkRef<Success<OrderKpisResponse>> {
    return watchRequest(this.ordersKpisUrl, OrderKpisSchema, params);
  }

  getGoogleKpis(
    params: OrderKpisParams,
  ): ResultOkRef<Success<GoogleKpisResponse>> {
    return watchRequest(this.googleKpisUrl, GoogleKpisSchema, params);
  }
}

const store = defineStore("metrics", () => ({
  api: markRaw(new MetricsApi()),
}));

export function useMetrics() {
  return store().api;
}
